import { Component } from '@angular/core';
import { ESlideMenuOptions } from 'src/app/services/config.service';

@Component({
    selector: 'app-products-operative',
    templateUrl: './products-operative.component.html',
    styleUrls: ['./products-operative.component.sass'],
    standalone: false
})
export class ProductsOperativeComponent {
  items = [
    ESlideMenuOptions.Mch_Products,
    ESlideMenuOptions.Mch_Lots,
    ESlideMenuOptions.Mch_BlockedBatches,
    ESlideMenuOptions.Mch_Rates,
  ];
}
